import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { getSearchParams } from '../utils/getSearchParams';
export const usePanorama = () => {
  const {
    panorama
  } = usePremiumEssentialsContext();
  const {
    debug
  } = getSearchParams();
  return {
    panorama,
    startTransaction: (name, data) => {
      debug && console.log('panorama: startTransaction', name, data);
      return panorama == null ? void 0 : panorama.transaction(name).start(data);
    },
    finishTransaction: (name, data) => {
      debug && console.log('panorama: finishTransaction', name, data);
      return panorama == null ? void 0 : panorama.transaction(name).finish(data);
    },
    reportError: (error, data) => {
      debug && console.log('panorama: reportError', error, data);
      return panorama == null ? void 0 : panorama.errorMonitor().reportError(error, data);
    }
  };
};
//# sourceMappingURL=usePanorama.js.map